import { render, staticRenderFns } from "./ReestrablecerPass.vue?vue&type=template&id=223e9d7b&scoped=true&"
import script from "./ReestrablecerPass.vue?vue&type=script&lang=ts&"
export * from "./ReestrablecerPass.vue?vue&type=script&lang=ts&"
import style0 from "./ReestrablecerPass.vue?vue&type=style&index=0&id=223e9d7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223e9d7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('223e9d7b', component.options)
    } else {
      api.reload('223e9d7b', component.options)
    }
    module.hot.accept("./ReestrablecerPass.vue?vue&type=template&id=223e9d7b&scoped=true&", function () {
      api.rerender('223e9d7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/ReestrablecerPass.vue"
export default component.exports